module.exports = __webpack_public_path__ + "img/logo2.e4849030.png";